import React from "react";
import "./styles.scss";

interface IProps {
  children: any;
  color: string;
  marginRight?: string;
  marginTop?: string;
  size: "xs" | "sm" | "md" | "lg";
  onClick?(): void;
}

const IconButton = (props: IProps) => {
  return (
    <div
      className={`icon-button ${props.size}`}
      style={{
        backgroundColor: props.color,
        marginRight: props.marginRight,
        marginTop: props.marginTop,
      }}
      onClick={props.onClick}
    >
      <div>{props.children}</div>
    </div>
  );
};

export default IconButton;
